import { Link } from 'react-router-dom'
import type { ReactNode } from 'react'

// Renders **bold** and [label](/internal-link) inside a plain string.
const TOKEN = /(\*\*[^*]+\*\*|\[[^\]]+\]\([^)]+\))/g

function RichText({ text }: { text: string }) {
  const parts = text.split(TOKEN).filter(Boolean)
  const nodes: ReactNode[] = parts.map((part, i) => {
    if (part.startsWith('**') && part.endsWith('**')) {
      return <strong key={i}>{part.slice(2, -2)}</strong>
    }
    const link = part.match(/^\[([^\]]+)\]\(([^)]+)\)$/)
    if (link) {
      const [, label, href] = link
      if (href.startsWith('/')) {
        return (
          <Link key={i} to={href}>
            {label}
          </Link>
        )
      }
      return (
        <a key={i} href={href} rel="noopener noreferrer">
          {label}
        </a>
      )
    }
    return <span key={i}>{part}</span>
  })
  return <>{nodes}</>
}

export default RichText
